// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useNavigation} from '@supermove/hooks';
import {OrganizationModel} from '@supermove/models';
import {Environment} from '@supermove/sdk';

// App
import ProjectCommentsWidget from '@shared/modules/Project/components/widgets/ProjectCommentsWidget';
import ProjectConversationsWidget from '@shared/modules/Project/components/widgets/ProjectConversationsWidget';
import ProjectDetailsWidget from '@shared/modules/Project/components/widgets/ProjectDetailsWidget';
import ProjectEventLogWidget from '@shared/modules/Project/components/widgets/ProjectEventLogWidget';
import useWidgetAnalytics from '@shared/modules/Project/components/widgets/hooks/useWidgetAnalytics';
import ProjectWidgetKind, {
  ProjectWidgetKindType,
} from '@shared/modules/Project/enums/ProjectWidgetKind';
import {SalesLeadsFiltersType} from '@shared/modules/Sales/components/SalesLeads';

const handleComposeEmail = ({
  projectUuid,
  emailTemplateUuid,
}: {
  projectUuid: string;
  emailTemplateUuid?: string;
}) => {
  const queryParams = emailTemplateUuid ? `?emailTemplateUuid=${emailTemplateUuid}` : '';
  window.open(
    `${Environment.getAppUrl()}/projects/${projectUuid}/email/compose${queryParams}`,
    '_blank',
  );
};

const LeadsListProjectPaneContent = ({
  widget,
  urlFilters,
  organization,
}: {
  widget?: ProjectWidgetKindType;
  urlFilters: SalesLeadsFiltersType;
  organization?: OrganizationModel;
}) => {
  const projectUuid = urlFilters.get('projectUuid');
  const {params} = useNavigation();

  useWidgetAnalytics({
    contextName: 'Sales Leads List Project Pane',
    params,
  });

  switch (widget) {
    case ProjectWidgetKind.PROJECT_DETAILS:
      return (
        <ProjectDetailsWidget
          projectUuid={projectUuid}
          block={params.block}
          handleUpdateBlock={(block: string) => urlFilters.handleUpdate({block})}
          organization={organization}
        />
      );
    case ProjectWidgetKind.CONVERSATIONS:
      return (
        <ProjectConversationsWidget
          projectUuid={projectUuid}
          handleComposeEmail={(emailTemplateUuid) =>
            handleComposeEmail({projectUuid, emailTemplateUuid})
          }
        />
      );
    case ProjectWidgetKind.COMMENTS:
      return <ProjectCommentsWidget projectUuid={projectUuid} />;
    case ProjectWidgetKind.EVENT_LOG:
      return <ProjectEventLogWidget projectUuid={projectUuid} />;
    default:
      return null;
  }
};

// --------------------------------------------------
// Data
// --------------------------------------------------
LeadsListProjectPaneContent.fragment = gql`
  ${ProjectDetailsWidget.fragment}

  fragment LeadsListProjectPaneContent on Organization {
    id
    ...ProjectDetailsWidget
  }
`;

export default LeadsListProjectPaneContent;
